import { render, staticRenderFns } from "./AthleteAdminDashboard.vue?vue&type=template&id=5d7bd55d&scoped=true&"
import script from "./AthleteAdminDashboard.vue?vue&type=script&lang=ts&"
export * from "./AthleteAdminDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./AthleteAdminDashboard.vue?vue&type=style&index=0&id=5d7bd55d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7bd55d",
  null
  
)

export default component.exports